// referring to https://github.com/GoogleChrome/chromium-dashboard/issues/3106, "-" has to be escaped because of "v" option
export const PATTERNS = {
  coupon: '^[^\\d]{3,}\\d{2,}\\s*$',
  houseNumber: "^\\s*[A-Za-zÀ-ÖØ-öø-ÿ\\d](?:[\\-,.'A-Za-zÀ-ÖØ-öø-ÿ\\d\\s]){0,9}\\s*$",
  iban: 'DE[a-zA-Z0-9]{2}\\s?([0-9]{4}\\s?){4}([0-9]{2})\\s?',
  name: "^\\s*[A-Za-zÀ-ÖØ-öø-ÿ](?:[\\-.'A-Za-zÀ-ÖØ-öø-ÿ\\s]){1,59}\\s*$",
  phoneNumber: '^\\s*(?:\\+\\d|0)(?: ?(- ?)?\\d){5,}\\s*$',
  email: '^\\s*([\\w.%+\\-]+)@([\\w\\-]+\\.)+(\\w{2,})\\s*$',
  zipCode: '^\\d{5}$',
} as const;
